// var jQuery = require('jquery');

// window.jQuery = jQuery;
// window.$ = jQuery;

require('jquery.easing');

// require('bootstrap/dist/js/bootstrap');
// Bootstrap Plugins
require('bootstrap/js/src/alert');
require('bootstrap/js/src/dropdown');
require('bootstrap/js/src/modal');
require('bootstrap/js/src/popover');
require('bootstrap/js/src/tab');
require('bootstrap/js/src/tooltip');
require('bootstrap/js/src/util');

require('magnific-popup');

// Keen's plugins
window.KTUtil = require('../theme/demo1/src/js/components/util.js');
window.KTApp = require('../theme/demo1/src/js/components/app.js');
window.KTCard = require('../theme/demo1/src/js/components/card.js');
window.KTCookie = require('../theme/demo1/src/js/components/cookie.js');
window.KTDialog = require('../theme/demo1/src/js/components/dialog.js');
window.KTHeader = require('../theme/demo1/src/js/components/header.js');
window.KTImageInput = require('../theme/demo1/src/js/components/image-input.js');
window.KTMenu = require('../theme/demo1/src/js/components/menu.js');
window.KTOffcanvas = require('../theme/demo1/src/js/components/offcanvas.js');
window.KTScrolltop = require('../theme/demo1/src/js/components/scrolltop.js');
window.KTToggle = require('../theme/demo1/src/js/components/toggle.js');
// window.KTWizard = require('../theme/demo1/src/js/components/wizard.js');
// require('../theme/demo1/src/js/components/datatable/core.datatable.js');
// require('../theme/demo1/src/js/components/datatable/datatable.checkbox.js');
// require('../theme/demo1/src/js/components/datatable/datatable.rtl.js');

// Keen layout base js
window.KTLayoutHeader = require('../theme/demo1/src/js/layout/base/header.js');
window.KTLayoutHeaderMenu = require('../theme/demo1/src/js/layout/base/header-menu.js');
window.KTLayoutHeaderTopbar = require('../theme/demo1/src/js/layout/base/header-topbar.js');
window.KTLayoutSubheader = require('../theme/demo1/src/js/layout/base/subheader.js');
window.KTLayoutBrand = require('../theme/demo1/src/js/layout/base/brand.js');
window.KTLayoutAside = require('../theme/demo1/src/js/layout/base/aside.js');
window.KTLayoutAsideToggle = require('../theme/demo1/src/js/layout/base/aside-toggle.js');
window.KTLayoutAsideMenu = require('../theme/demo1/src/js/layout/base/aside-menu.js');
window.KTLayoutContent = require('../theme/demo1/src/js/layout/base/content.js');
window.KTLayoutFooter = require('../theme/demo1/src/js/layout/base/footer.js');


window.KTLayoutStickyCard = require('../theme/demo1/src/js/layout/base/sticky-card.js');
window.KTLayoutStretchedCard = require('../theme/demo1/src/js/layout/base/stretched-card.js');


// Keen layout extended js
// window.KTLayoutChat = require('../theme/demo1/src/js/layout/extended/chat.js');
// window.KTLayoutDemoPanel = require('../theme/demo1/src/js/layout/extended/demo-panel.js');
// window.KTLayoutExamples = require('../theme/demo1/src/js/layout/extended/examples.js');
window.KTLayoutQuickActions = require('../theme/demo1/src/js/layout/extended/quick-actions.js');
window.KTLayoutQuickNotifications = require('../theme/demo1/src/js/layout/extended/quick-notifications.js');
window.KTLayoutQuickPanel = require('../theme/demo1/src/js/layout/extended/quick-panel.js');
window.KTLayoutQuickSearch = require('../theme/demo1/src/js/layout/extended/quick-search.js');
window.KTLayoutQuickUser = require('../theme/demo1/src/js/layout/extended/quick-user.js');
window.KTLayoutScrolltop = require('../theme/demo1/src/js/layout/extended/scrolltop.js');
// window.KTLayoutSearch = window.KTLayoutSearchOffcanvas = require('../theme/demo1/src/js/layout/extended/search.js');



const feather = require('feather-icons');

// Feather Icons
feather.replace();

require('../theme/demo1/src/js/layout/initialize.js');



// var async = async || [];
// while(async.length) { // there is some syncing to be done
//     var obj = async.shift();
//     if (obj[0] =="ready") {
//         $(obj[1]);
//     }else if (obj[0] =="load"){
//         $(window).load(obj[1]);
//     }
// }
// async = {
//     push: function(param){
//         if (param[0] =="ready") {
//             $(param[1]);
//         }else if (param[0] =="load"){
//             $(window).load(param[1]);
//         }
//     }
// };

$(function() {
    // async.push(["ready", function() {
    // if ($('.popup-gallery').length) {
    //     $('.popup-gallery').magnificPopup({
    //         disableOn: 700,
    //         type: 'iframe',
    //         mainClass: 'mfp-fade',
    //         removalDelay: 160,
    //         preloader: false,
    //         fixedContentPos: false,
    //         gallery: {
    //             enabled: true
    //         },
    //     });
    // }

    if ($('.popup-gallery').length) {
        $('.popup-gallery').each(function() {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile mfp-figure',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                },
                zoom: {
                    enabled: true, // By default it's false, so don't forget to enable it

                    duration: 300, // duration of the effect, in milliseconds
                    easing: 'ease-in-out', // CSS transition easing function

                    // The "opener" function should return the element from which popup will be zoomed in
                    // and to which popup will be scaled down
                    // By defailt it looks for an image tag:
                    opener: function(openerElement) {
                        // openerElement is the element on which popup was initialized, in this case its <a> tag
                        // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                        return openerElement.is('img') ? openerElement : openerElement.find('img');
                    }
                },
                callbacks: {
                    beforeOpen: function() {
                        // just a hack that adds mfp-anim class to markup
                        this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                        this.st.mainClass = this.st.el.attr('data-effect');
                    },
                    buildControls: function() {
                        // re-appends controls inside the main container
                        // this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                }
            });
        });
    }

});